import { useState, ReactNode } from 'react';
import { ProfileModalContext } from './profile-modal-context';
import { useProfileModal } from './profile-modal-utils';

export function ProfileModalProvider({ children }: { children: ReactNode }) {
  const [isOpen, setIsOpen] = useState(false);

  const openModal = () => setIsOpen(true);
  const closeModal = () => setIsOpen(false);

  return (
    <ProfileModalContext.Provider value={{ isOpen, openModal, closeModal }}>
      {children}
    </ProfileModalContext.Provider>
  );
}

// eslint-disable-next-line react-refresh/only-export-components
export { useProfileModal };